/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListQueryResponse, IncidentInvestigationControllerListQueryParams } from "../../models/incidentAgentController/IncidentInvestigationControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerList } from "../../clients/incident-agentService/incidentInvestigationControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerListQueryKey = (params: IncidentInvestigationControllerListQueryParams = {}) => [{
  url: '/api/v1/incident-agent/investigations'
}, ...(params ? [params] : [])] as const;
export type IncidentInvestigationControllerListQueryKey = ReturnType<typeof incidentInvestigationControllerListQueryKey>;
export function incidentInvestigationControllerListQueryOptions(params?: IncidentInvestigationControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerListQueryKey(params);
  return queryOptions<IncidentInvestigationControllerListQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerListQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerList(params, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations}
 */
export function useIncidentInvestigationControllerList<TData = IncidentInvestigationControllerListQueryResponse, TQueryData = IncidentInvestigationControllerListQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerListQueryKey>(params?: IncidentInvestigationControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerListQueryKey(params);
  const query = useQuery({
    ...incidentInvestigationControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}